import { createAsyncThunk } from '@reduxjs/toolkit'
import { updateAdminDetailsService } from 'network/services/admins.service'
import { getUserInfoService } from 'network/services/users.service'
import { getAdminId } from 'utils/common-services/cookie.services'

/**
 * Fetch User info who is logged in
 */
export const fetchUserInformation = createAsyncThunk(
  'fetch/UserInfo',
  async (_, thunkApi) => {
    try {
      const adminId = getAdminId()
      const res = await getUserInfoService(adminId)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

/**
 * Update User info who is logged in
 */
export const updateUserInformation = createAsyncThunk(
  'update/UserInfo',
  async ({ email, firstName, lastName, onSuccess, onError }, thunkApi) => {
    try {
      const adminId = Number(getAdminId())
      const res = await updateAdminDetailsService({ adminId, email, firstName, lastName })
      onSuccess()
      return res
    } catch (error) {
      onError()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
